import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import services from 'services/services';

/**
 * @typedef {Object} UseCreatePanelistMutationVariables
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} email
 * @property {number} panelId
 * @property {number} [skipDoubleOptIn]
 */

/** @typedef {import('services/services').Person} UpdateIsOptInConfirmedResponse */

/** @typedef {Omit<UseMutationOptions<UpdateIsOptInConfirmedResponse, Error, UseCreatePanelistMutationVariables, unknown>, 'mutationKey' | 'mutationFn'>} UseCreatePanelistMutationOptions */

/**
 *
 * @param {UseCreatePanelistMutationOptions} [options={}]
 */
export const useCreatePanelistMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['create-panelist'],
        /** @param {UseCreatePanelistMutationVariables} payload */
        mutationFn: payload => services.createPerson(payload)
    });
};
